import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { Headline } from '../../components/Headline/Headline.js';
import { Button } from '../Button/Button.js';
import { Dialog } from '../DialogManager/Dialog.js';
import { useDialogManager } from '../DialogManager/useDialogManager.js';
import { Img } from '../Img/Img.js';
export const ResponseTypeDialog = JSX(function ({ responseType, typeForm, }) {
    const responseOK = responseType === 'OK';
    const statusIcon = responseOK ? 'ResponseOKIcon' : 'ResponseFailIcon';
    const { close } = useDialogManager();
    const handleClose = useCallback(() => {
        close();
    }, []);
    const responseOKDescription = typeForm === 'ANTIFRAUD'
        ? `Сообщение отправлено. Для уточнения информации с Вами могут связаться работники Банка либо Вы
  можете самостоятельно позвонить по номеру контакт-центра +78001000100. Будьте внимательны, работники Банка
   не звонят с использованием мессенджеров.`
        : 'Совсем скоро мы с вами свяжемся';
    return (_jsx(Dialog, { className: "my-6xl max-w-lg w-full min-h-fit mx-auto ", children: _jsxs("div", { className: "flex flex-col gap-lg items-center rounded-md space-x-m", children: [_jsx(Img, { image: { icon: statusIcon, iconVersion: 'normal' }, width: "136", height: "136" }), _jsx(Headline, { className: "w-full", title: responseOK ? 'Ваша заявка отправлена' : 'Не удалось отправить заявку', description: responseOK ? responseOKDescription : 'Пожалуйста, повторите позднее', headlineVersion: "XS", isEmbedded: true }), _jsx(Button, { type: "button", onClick: handleClose, children: "\u0425\u043E\u0440\u043E\u0448\u043E" })] }) }));
});
//# sourceMappingURL=ResponseTypeDialog.js.map